import React from 'react';

import { DirectorItemProps } from './interfaces';

const DirectorItem = (props: DirectorItemProps) => {
  const { director } = props;
  return (
    <div className="flex min-h-[116px] w-[258px] flex-row items-center gap-12">
      <img
        loading="lazy"
        className="h-[78px] w-[78px] flex-shrink-0 rounded-full"
        src={director.imageUrl}
        alt={`Image of ${director.name}`}
      />
      <div className="flex flex-col">
        <p className="m-0 pt-16 text-caption-lg leading-tight">{director.name}</p>
        <span className="m-0 text-caption-sm text-grayscale-gray">{director.title}</span>
      </div>
    </div>
  );
};

export default DirectorItem;
